export enum InstrumentStatus {
  Valid,
  Expired,

  // This status is set when the instrument cannot be used due to
  // issues regarding service failures that prevent us from using them.
  TemporarilyUnavailable,
}
